import type { KnowledgeItemData } from "./api";
import { buildParticipantsFromTemplate } from "./groupTalk";
import type {
  GroupTalkDraft,
  GroupTalkKnowledgeAttachmentDraft,
} from "./groupTalkSessionStorage";
import { getKnowledgeItemDisplayName } from "./knowledge";

export function knowledgeAttachmentFromItem(
  item: KnowledgeItemData
): GroupTalkKnowledgeAttachmentDraft | null {
  if (item.type !== "pdf" && item.type !== "executive_memo" && item.type !== "url") {
    return null;
  }
  const type = item.type === "url"
    ? "url"
    : item.type === "executive_memo"
      ? "executive_memo"
      : "pdf";

  return {
    id: item.id,
    type,
    title: getKnowledgeItemDisplayName(item),
    originalFilename: item.original_filename,
    status: item.status,
    failureReason: item.failure_reason,
    pageCount: item.page_count,
    textExtractable: item.text_extractable,
    aiProcessingAllowed: item.ai_processing_allowed,
    aiPreparationStatus: item.ai_preparation_status ?? null,
    hasSummary: Boolean(item.has_summary),
    summarizedAt: item.summarized_at ?? null,
  };
}

export function buildKnowledgeWallTalkDraft(item: KnowledgeItemData): GroupTalkDraft {
  return {
    templateId: "custom",
    title: "ナレッジから壁打ち",
    description: "選択したナレッジを参考資料として使い、相談内容に合わせてメンバーを選びます。",
    participants: buildParticipantsFromTemplate("custom"),
    mode: "custom",
    consultationText: "",
    memberEditingLocked: false,
    knowledgeAttachment: knowledgeAttachmentFromItem(item),
  };
}
